export const PACKAGE_TYPE_REGISTRATION = 'REGISTRATION';
export const PACKAGE_TYPE_SOCIAL = 'SOCIAL';

export const eventPackagesStatusesOption = {
  [PACKAGE_TYPE_REGISTRATION]: "Inscription",
  [PACKAGE_TYPE_SOCIAL]: "Social",
};
